import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

export default function NgpHiddenField(props) {
    const { fieldName, defaultValue } = props;

    return (
        <Controller
            name={fieldName}
            defaultValue={defaultValue}
            render={({ ref, value }) => {
                return <input type="hidden" name={fieldName} ref={ref} value={value} />;
            }}
        />
    );
}

NgpHiddenField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
};

NgpHiddenField.defaultProps = {
    defaultValue: '',
};
